import React from "react";
import { colors } from "../../../share/constants/enums";
import Button from "../../../components/common/button";
import { Link } from "react-router-dom";
import YupupScreen from "./../../../assets/icons/LogoScreen.svg";
import Successful from "./../../../assets/icons/successfulicon.svg";

const ResetSuccessful = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen ">
      <div className="object-cover">
        <img
          className="block h-12 xl:h-15.3 xl:w-26.9"
          alt="yupup-screen-logo"
          src={YupupScreen}
        />
      </div>
      <div className="flex justify-center items-center h-15 lg:h-15 lg:w-full xl:h-15 xl:w-full">
        <img src={Successful} alt="reset" />
      </div>
      <div className="flex flex-col space-y-2 text-center">
        <p className="text-heading lg:text-xl xl:text-xl font-bold">
          Reset Successfully
        </p>
        <p className="text-base lg:text-lg xl:text-lg font-normal">
          Your Password Has Been Successfully Reset.
        </p>
        <Link to="/login" className="no-underline">
          <Button
            className="w-31 md:w-40 lg:w-40 xl:w-40"
            title="Sign In"
            color={colors.primaryBlue}
            htmlType="submit"
          />
        </Link>
      </div>
    </div>
  );
};

export default ResetSuccessful;
